import React from 'react'
import { FaWhatsapp } from 'react-icons/fa'
import { FiPhoneCall } from 'react-icons/fi'
import { MdOutlinePhoneCallback } from 'react-icons/md'
import { TiMail } from 'react-icons/ti'
import { Link } from 'react-router-dom'

const Support = () => {
  document.title = 'MACRUM | Support'
  document.querySelector('meta[rel="canonical"]').setAttribute('href', 'https://macrum.in/support')

  return (
    <>
      <div className='pt-28'>
        <div className='w-fit grid sm:grid-cols-2 md:grid-flow-col items-center gap-y-8 sm:gap-x-4 mx-auto'>
          <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
            <div>
              <Link to='mailto:support@macrum.in'>
                <TiMail className='text-5xl mx-auto' />
                <p className='text-2xl font-semibold'>Mail</p>
              </Link>
            </div>
          </div>
          <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
            <div>
              <Link to='tel:+91 8900689991'>
                <FiPhoneCall className='text-5xl mx-auto' />
                <p className='text-2xl font-semibold'>Call Us</p>
              </Link>
            </div>
          </div>
          <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
            <div>
              <Link to=''>
                <MdOutlinePhoneCallback className='text-5xl mx-auto' />
                <p className='text-2xl font-semibold'>Call Back</p>
              </Link>
            </div>
          </div>
          <div className='flex-center border w-40 h-28 bg-blue-950 border-blue-800 rounded-md'>
            <div>
              <Link to='https://wa.me/+918900689991?text=Hi'>
                <FaWhatsapp className='text-5xl mx-auto' />
                <p className='text-2xl font-semibold'>WhatsApp</p>
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className='pt-16'></div>
    </>
  )
}

export default Support
